import { set } from 'src/core/redux/actions';
import { selectStateData } from 'src/core/redux/selectors';

export const addDetails = (namespace) => (data) => (dispatch, getState) => {
  const previousData = selectStateData(namespace)(getState());

  dispatch(set(namespace, '', { ...previousData, ...data }));
};
